module.exports = __webpack_public_path__ + "static/media/Logo.3fb8d227.png";